/**
 * @description: 产生随机点
 * @param {*} position：中心点坐标
 * @param {*} num：随机点数量
 * @return {*}
 */
function generateRandomPosition(position, num) {
    let list = []
    for (let i = 0; i < num; i++) {
        // random产生的随机数范围是0-1，需要加上正负模拟
        let lon = position[0] + Math.random() * 0.04 * (i % 2 === 0 ? 1 : -1);
        let lat = position[1] + Math.random() * 0.04 * (i % 2 === 0 ? 1 : -1);
        list.push([lon, lat])
    }
    return list
}

export default generateRandomPosition;
